import type { Container } from "pixi.js";
import type { ScreenShape } from "./ScreenShape";
import { resolveResponsive, type Responsive } from "./Responsive";

/** Where a node sits for a shape: its position (design units, y-down), scale and visibility. */
export interface Placement {
  x: number;
  y: number;
  scale?: number;
  visible?: boolean;
}

/** Applies the shape's placement to `node`. */
export function applyPlacement(node: Container, rule: Responsive<Placement>, shape: ScreenShape): void {
  const placement = resolveResponsive(rule, shape);
  node.visible = placement.visible ?? true;
  node.position.set(placement.x, placement.y);
  const scale = placement.scale ?? 1;
  node.scale.set(scale, scale);
}

/**
 * Nudges `node` on X so its authored box (centred on the node) stays inside `bounds`, both given in
 * the node's PARENT space. Returns the nudge applied (0 when the box was inside).
 */
export function keepInsideX(node: Container, box: { width: number; height: number }, bounds: { x: number; y: number; width: number; height: number }): number {
  const half = (box.width * node.scale.x) / 2;
  const left = node.position.x - half;
  const right = node.position.x + half;
  let nudge = 0;
  if (right > bounds.x + bounds.width) nudge = bounds.x + bounds.width - right;
  else if (left < bounds.x) nudge = bounds.x - left;
  if (nudge !== 0) node.position.x += nudge;
  return nudge;
}
